module.exports = __webpack_public_path__ + "static/media/dark.78ed3434.png";